export const filterByCondition = (data, filterValue, key, isArray = false) => {
  if (!filterValue) return data;
  return data.filter((item) => {
    if (isArray) {
      return item[key] && item[key].includes(filterValue);
    }
    return (
      item[key] && item[key].toLowerCase().includes(filterValue.toLowerCase())
    );
  });
};

export const filterByDateRange = (data, startDate, endDate) => {
  if (!startDate && !endDate) return data;

  return data.filter((item) => {
    const trainingStart = new Date(item.training_start_time);
    const filterStart = startDate ? new Date(startDate) : null;
    const filterEnd = endDate ? new Date(endDate) : null;

    if (filterEnd) {
      filterEnd.setHours(23, 59, 59, 999);
    }

    return (
      (!filterStart || trainingStart >= filterStart) &&
      (!filterEnd || trainingStart <= filterEnd)
    );
  });
};

export const filterBySearchQuery = (data, query) => {
  if (!query) return data;
  const lowerCaseQuery = query.toLowerCase();

  return data.filter((training) => {
    return (
      training.title.toLowerCase().includes(lowerCaseQuery) ||
      (training.course_provider_area &&
        training.course_provider_area.toLowerCase().includes(lowerCaseQuery)) ||
      (training.course_competences &&
        training.course_competences.some((comp) =>
          comp.toLowerCase().includes(lowerCaseQuery)
        )) ||
      (training.course_education_type &&
        training.course_education_type.some((type) =>
          type.toLowerCase().includes(lowerCaseQuery)
        )) ||
      (training.course_learning_format &&
        training.course_learning_format
          .toLowerCase()
          .includes(lowerCaseQuery)) ||
      (training.course_professional_group &&
        training.course_professional_group.some((group) =>
          group.toLowerCase().includes(lowerCaseQuery)
        ))
    );
  });
};
